// extracted by mini-css-extract-plugin
module.exports = {"djablue":"#0d1064","verdjavu":"#62f4a4","grayDark":"#333","verdjavuDark":"#58d89c"};